export const THEMES = [
  { 
    id: 'modern', 
    name: 'Modern',
    description: 'Clean and contemporary',
    colors: { 
      primary: '#3B82F6', 
      secondary: '#60A5FA',
      bg: '#F8FAFC', 
      text: '#1E293B',
      border: '#E2E8F0'
    },
    fonts: {
      heading: 'Inter, sans-serif',
      body: 'Inter, sans-serif'
    }
  },
  { 
    id: 'dark', 
    name: 'Dark',
    description: 'Dark mode aesthetic',
    colors: { 
      primary: '#10B981', 
      secondary: '#34D399',
      bg: '#111827', 
      text: '#F9FAFB',
      border: '#374151'
    },
    fonts: {
      heading: 'Inter, sans-serif',
      body: 'Inter, sans-serif'
    }
  },
  { 
    id: 'warm', 
    name: 'Warm',
    description: 'Cozy warm tones',
    colors: { 
      primary: '#F59E0B', 
      secondary: '#FBBF24',
      bg: '#FEF3C7', 
      text: '#92400E',
      border: '#FDE68A'
    },
    fonts: {
      heading: 'Georgia, serif',
      body: 'Georgia, serif'
    }
  },
  { 
    id: 'elegant', 
    name: 'Elegant',
    description: 'Sophisticated purple theme',
    colors: { 
      primary: '#8B5CF6', 
      secondary: '#A78BFA',
      bg: '#FAF5FF', 
      text: '#581C87',
      border: '#E9D5FF'
    },
    fonts: {
      heading: 'Playfair Display, serif',
      body: 'Inter, sans-serif'
    }
  },
  { 
    id: 'ocean', 
    name: 'Ocean',
    description: 'Fresh ocean blues',
    colors: { 
      primary: '#06B6D4', 
      secondary: '#22D3EE',
      bg: '#ECFEFF', 
      text: '#164E63',
      border: '#CFFAFE'
    },
    fonts: {
      heading: 'Poppins, sans-serif',
      body: 'Poppins, sans-serif'
    }
  },
  { 
    id: 'forest', 
    name: 'Forest',
    description: 'Natural green theme',
    colors: { 
      primary: '#059669', 
      secondary: '#10B981',
      bg: '#F0FDF4', 
      text: '#065F46',
      border: '#D1FAE5'
    },
    fonts: {
      heading: 'Merriweather, serif',
      body: 'Lato, sans-serif'
    }
  }
];

export const getTheme = (id) => THEMES.find(theme => theme.id === id) || THEMES[0];
export const getAvailableThemes = () => THEMES;